import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

const containerCss = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative"
});

const cardCss = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    padding: `${token("space.200")} ${token("space.200")} ${token(
        "space.200"
    )} ${token("space.150")}`,
    backgroundColor: token("color.background.input"),
    border: `1px solid ${token("color.border")}`,
    borderRadius: token("space.075"),
    width: "100%",
    boxSizing: "border-box"
});

const contentRowCss = css({
    display: "flex",
    gap: "15px",
    alignItems: "center",
    width: "100%"
});

const logoIconCss = css({
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "width": token("space.200"),
    "height": token("space.200"),
    "flexShrink": 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "& svg": {
        width: token("space.200"),
        height: token("space.200")
    }
});

const textContentCss = css({
    display: "flex",
    flex: "1 0 0",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    minHeight: token("space.0"),
    minWidth: token("space.0"),
    color: wacToken("color.neutral.dark500"),
    whiteSpace: "pre-wrap"
});

const titleCss = css({
    margin: 0,
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    color: token("color.text.subtle"),
    fontFamily: "Atlassian Sans",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});

const OrganizationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 2C1 0.895431 1.89543 0 3 0H11C12.1046 0 13 0.89543 13 2V14.5H14V16H0V14.5H1V2ZM2.5 14.5H4.5V10.75C4.5 10.3358 4.83579 10 5.25 10H8.75C9.16421 10 9.5 10.3358 9.5 10.75V14.5H11.5V2C11.5 1.72386 11.2761 1.5 11 1.5H3C2.72386 1.5 2.5 1.72386 2.5 2V14.5ZM8 14.5V11.5H6V14.5H8ZM6 4.5H4V3H6V4.5ZM10 4.5H8V3H10V4.5ZM4 6H6V7.5H4V6ZM8 6H10V7.5H8V6Z"
                fill="#292A2E"
            />
        </svg>
    );
};

export interface OrganizationCardProps {
    organizationName: string;
}

export const OrganizationCard = ({
    organizationName
}: OrganizationCardProps) => {
    return (
        <div css={containerCss}>
            <div css={cardCss}>
                <div css={contentRowCss}>
                    <div css={logoIconCss}>
                        <OrganizationIcon />
                    </div>
                    <div css={textContentCss}>
                        <p css={titleCss}>{organizationName}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
